var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 471.78 471.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #efefef;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "176.53 295.1 161.51 280.09 170.16 211.46 72.61 116.86 176.06 62.91 261.56 86.17 467.53 .05 471.63 0 176.53 295.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "404.73 291.57 381.46 206.07 471.78 4.85 471.28 .36 176.53 295.11 191.14 309.72 257.33 298.66 350.77 395.02 404.73 291.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.72 336.97 16.4 471.04 0 454.64 134.07 304.32 166.72 336.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.2 462.84 16.4 471.04 166.72 336.97 150.39 320.64 8.2 462.84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEscape);
export default __webpack_public_path__ + "static/media/icon-escape.b1789959b16c042e20e2286dbd01f660.svg";
export { ForwardRef as ReactComponent };